import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgxPrintModule } from 'ngx-print';

@Component({
    selector: 'lib-print-1x3-template',
    imports: [
        MatButtonModule,
        MatIconModule,
        NgxPrintModule,
    ],
    templateUrl: './print-1x3-template.component.html',
    styleUrl: './print-1x3-template.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class Print1x3TemplateComponent { }
